import React from "react";

interface IDefaultLayoutProps {
  children?: React.ReactNode;
}

const DefaultLayout: React.FC<IDefaultLayoutProps> = ({ children }) => (
  <div className="bg-[var(--background-default-variant)]">{children}</div>
);

export default DefaultLayout;
